export const REGISTER_BOOK_CHART_CONSTANT = {
  //charts
  REGISTER_BOOK_COUNT: "/dashboard/register/counts",
  REGISTER_STATUS_DATA: "/dashboard/register-book/count/status",
};
